<template>
  <div class="w1200 zhaogu-page">
    <div class="page-bar">
      <span class="back-btn" @click="goBack">← 返回</span>
    </div>
    <div class="page-title">我的实战超市购买记录</div>

    <el-table v-loading="loading" :data="list" empty-text="暂无购买记录"
      :header-cell-style="{ 'textAlign': 'center' }" :cell-style="{ 'textAlign': 'center' }">
      <el-table-column type="index" label="序号" width="60"></el-table-column>
      <el-table-column prop="title" label="实战方案" show-overflow-tooltip></el-table-column>
      <el-table-column label="彩种" width="100">
        <template slot-scope="{ row }">{{ lotteryTypeName(row.preType) }}</template>
      </el-table-column>
      <el-table-column prop="preNumber" label="期数" width="110"></el-table-column>
      <el-table-column label="缩币价格" width="120">
        <template slot-scope="{ row }">{{ money(row.coin) }} 缩币</template>
      </el-table-column>
      <el-table-column label="购买状态" width="110">
        <template slot-scope="{ row }">
          <el-tag :type="row.status == 1 ? 'success' : (row.status == 2 ? 'warning' : 'info')" size="small">
            {{ row.status == 1 ? '已支付' : (row.status == 2 ? '已退款' : '待支付') }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="购买时间" width="170"></el-table-column>
      <el-table-column label="操作" width="100" fixed="right">
        <template slot-scope="{ row }">
          <el-button type="text" @click="download(row)">下载方案</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { getMyPurchaseList } from "@/api/personalCenter";

const LOTTERY_MAP = {
  '0': '双色球', '1': '大乐透', '2': '福彩3D', '3': '排列3',
  '5': '七乐彩', '6': '7星彩', '7': '排列5', '8': '快乐8',
};

export default {
  name: "MarketMyPurchase",
  data() {
    return {
      list: [],
      loading: false,
    };
  },
  mounted() {
    this.loadList();
  },
  methods: {
    goBack() {
      this.$router.push("/sttzzbfzx/chaoshi");
    },
    lotteryTypeName(type) {
      return LOTTERY_MAP[type] || type || "-";
    },
    money(v) {
      if (v == null || v === "") return "-";
      const n = Number(v);
      return isNaN(n) ? v : n;
    },
    // 我的购买：GET /stage-api/assist/market/my/purchase/list（返回 Result<List>，无分页）
    loadList() {
      this.loading = true;
      getMyPurchaseList({})
        .then((res) => {
          const data = res && res.data !== undefined ? res.data : res;
          this.list = Array.isArray(data) ? data : (data && data.rows) || [];
        })
        .catch(() => {
          this.list = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 下载已购买的方案：走统一下载接口（已购买幂等不重复扣费），返回文件流以 blob 保存
    download(row) {
      if (!row || !row.marketId) return;
      this.$message.info("正在准备下载…");
      this.$http.get("/stage-api/assist/market/scheme/download", {
        params: { marketId: row.marketId },
        responseType: "blob",
      }).then((res) => {
        const blob = (res && res instanceof Blob) ? res : (res && res.data);
        if (!blob) {
          this.$message.error("下载失败：未获取到文件");
          return;
        }
        const fileName = (row.title || "实战方案") + ".xlsx";
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        setTimeout(() => URL.revokeObjectURL(url), 1000);
      }).catch(() => {
        this.$message.error("下载失败，请检查登录状态或网络后重试");
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.zhaogu-page {
  background: #ffffff;
  padding: 20px;
  margin-top: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  border-radius: 8px;

  .page-bar {
    margin-bottom: 10px;
  }

  .back-btn {
    display: inline-block;
    cursor: pointer;
    color: #347caf;
    font-size: 14px;
    padding: 6px 14px;
    border: 1px solid #347caf;
    border-radius: 5px;
    transition: all 0.2s;

    &:hover {
      background-color: #347caf;
      color: #ffffff;
    }
  }

  .page-title {
    font-size: 22px;
    font-weight: bold;
    color: #347caf;
    text-align: center;
    padding: 10px 0 20px;
    border-bottom: 2px solid #347caf;
    margin-bottom: 20px;
  }
}
</style>
